import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    if (!sessionId) {
      navigate("/admin", { replace: true });
      return;
    }
    authApi
      .post("/auth/session", { session_id: sessionId })
      .then((r) => {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin", { state: { user: r.data }, replace: true });
      })
      .catch(() => {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin", { replace: true });
      });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a]" data-testid="auth-callback-loading">
      <div className="text-center">
        <div className="w-12 h-12 rounded-full border-2 border-[#ccff00] border-t-transparent animate-spin mx-auto mb-4" />
        <p className="text-white/60 uppercase tracking-widest text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
